import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Unsubscribable } from 'rxjs/internal/types';

@Component({
  template: ''
})
export abstract class BaseComponent implements OnDestroy {
  private subscriptions: Unsubscribable[] = [];

  public ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub?.unsubscribe();
    });
  }

  protected subscribe(subscription: Unsubscribable) {
    this.subscriptions.push(subscription);
  }

  protected whenDestructing(onDestroy: () => void) {
    this.subscriptions.push(new Subscription(onDestroy));
  }
}
